import Vue from 'vue/dist/vue.min.js';
import template from 'shared/meter-selector-input-box.hbs';

Vue.component(
    "ms-input-box",
    {
        props: {
            title: String,
            description: String,
            switcher: Object,
            input: Object,
            dropdown: Object,
            dropdownOptions: Array,
            onChange: Function,
            defaultValue: { type: Object, default: {} },
            onTriggerEvent: Function
        },
        data(){
            const data = {
                switcherValue: false,
                dropdownValue: '',
                inputValue: '',
                switcherField: this.switcher,
                inputField: this.input,
                changingMemo: this.defaultValue,
                inputErrorMessage: null, 
                taggingInputValue: '',
            };

            if (this.defaultValue.switcher) {
                data.switcherValue = this.switcher.right.value === this.defaultValue.switcher.value;
            }

            if (this.defaultValue.dropdown) {
                data.dropdownValue = this.defaultValue.dropdown.value;
            }

            if (this.defaultValue.input) {
                data.inputValue = this.defaultValue.input.toString();
            }

            data.taggingInputValue = data.inputValue;

            return data;
        },
        watch: {
            switcherValue: {
                handler(v, a) {
                    if (!this.switcherField) {
                        return;
                    }
                    const option = v ? this.switcher.right : this.switcher.left;

                    this.changingMemo =  {
                        ...this.changingMemo,
                        switcher: option,
                    };

                    if ((a !== undefined || this.dropdownValue === '') && option && this.dropdownOptions) {
                        if (this.dropdownOptions[option.value]) {
                            const dropdownOption = this.dropdownOptions[option.value][0] || {};
                            this.dropdownValue = dropdownOption.value || '';
                        }
                    }
                },
                immediate: true
            },
            dropdownValue: {
                handler(v) {
                    if (!this.dropdownField) {
                        return;
                    }

                    this.changingMemo =  {
                        ...this.changingMemo,
                        dropdown: this.dropdownField.options.find(o => o.value === v),
                    }
                },
                immediate: true
            },
            inputValue: {
                handler(v) {
                    if (!this.inputField) {
                        return;
                    }

                    const { noNegative, decimals = 2 } = this.input;
                    let dashes = 0;
                    let points = 0;

                    let value = v.replace(/[^0-9.]|\./g, function($0){
                            if ( (!noNegative && $0 === '-' && v.indexOf('-') === 0 && !(dashes++)) || (decimals > 0 && $0 === '.' && !(points++)) ) {
                            return $0;
                        }

                        return '';
                    });
                    
                    const dp = value.indexOf('.');
                    if (dp > -1) {
                        const diff = value.length - dp - 1 - decimals;

                        if (diff > 0) {
                           value = value.substring(0, value.length - diff);
                        }
                    }

                    const numericValue = parseFloat(value);
                    this.inputErrorMessage = null;

                    if (this.input.validation) {
                        const {error, min = null, max} = this.input.validation;

                        if ((min !== null && min > value) || (max && max < value)) {
                             this.inputErrorMessage = error;
                        }
                    }

                    this.inputValue = value;

                    this.changingMemo =  {
                        ...this.changingMemo,
                        input: value === '' ? '' : parseFloat(value),
                    };
                },
                immediate: true
            },
            changingMemo(v) {
                this.hasChange();
            },
            taggingValue(){
                this.onTriggerEvent({ value: this.taggingValue });
            }
        },
        computed:  {
            taggingValue(){
                return this.taggingInputValue + (this.option ? ' ' + (this.option.label || this.option.value) : '');
            },
            dropdownField(){
                if(!this.dropdownOptions){
                    return null;
                }

                const option = (this.switcherValue ? this.switcher.right : this.switcher.left) || {};

                return { options: this.dropdownOptions[option.value] || [] };
            },
            inputTitle(){
                const ctx = this;
                return {
                    props: {
                        option: Object
                    }, 
                    template: `<span>${ctx.inputField.title}</span>`
                }
            },
            option(){
                return this.dropdownField ? this.changingMemo.dropdown : this.changingMemo.switcher;
            } 
        },
        mounted() {
            this.hasChange();
        },
        beforeUnmount() {
        },
        methods: {
            
            hasChange(){
                this.onChange && this.onChange(this.changingMemo);
            },
            onBlurInput(){
                this.taggingInputValue = this.inputValue;
            }
        }, 
        template
    }
);
